<template>
  <div class="tc-login">
    <div class="login-card">
      <div class="login-header">
        <img class="login-logo" :src="loginHead" alt="みんなの勤怠">
      </div>
      <form @submit.prevent="login" class="login-form">
        <div class="field-group">
          <label>メールアドレス</label>
          <input type="email" v-model="id" class="form-control" placeholder="example@mail.com" required>
        </div>
        <div class="field-group">
          <label>パスワード</label>
          <div class="password-wrap">
            <input :type="showPassword ? 'text' : 'password'" v-model="password" class="form-control" placeholder="パスワード" required>
            <button type="button" class="pw-toggle" @click="showPassword = !showPassword">
              <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
        </div>
        <div class="remember-row">
          <label class="remember-label">
            <input type="checkbox" v-model="rememberMe">
            <span>ログイン情報を保存する</span>
          </label>
        </div>
        <button type="submit" class="btn-login" :disabled="isLoading">
          <span v-if="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          <span v-else>ログイン</span>
        </button>
        <p class="forgot-link">
          <a href="#" @click.prevent="showForgotModal = true">パスワードを忘れた方はこちら</a>
        </p>
      </form>
    </div>

    <!-- Shop select modal -->
    <div v-if="showShopSelect" class="modal-overlay" @click.self="showShopSelect = false">
      <div class="modal-box">
        <div class="modal-box-header">
          <h6 class="modal-box-title">ログイン店舗を選択</h6>
        </div>
        <div class="modal-box-body">
          <button v-for="shop in shops" :key="shop.id" class="shop-select-btn" @click="selectShop(shop)">
            <i class="fas fa-store mr-2"></i>{{ shop.shop_name }}
          </button>
        </div>
      </div>
    </div>

    <!-- パスワードリセット依頼モーダル -->
    <div v-if="showForgotModal" class="modal-overlay" @click.self="showForgotModal = false">
      <div class="modal-box">
        <div class="modal-box-header">
          <h6 class="modal-box-title">パスワード再設定</h6>
          <button class="modal-close" @click="showForgotModal = false">&times;</button>
        </div>
        <div class="modal-box-body">
          <p style="font-size:13px;color:#4a5568;">ご登録いただいたメールアドレスを入力してください。パスワード再設定用URLをお送りいたします。</p>
          <input type="email" v-model="resetEmail" class="form-control" placeholder="メールアドレス">
          <p v-if="resetMessage" :style="{ color: resetMessageError ? '#e53e3e' : '#38a169', fontSize: '13px', marginTop: '8px' }">{{ resetMessage }}</p>
        </div>
        <div class="modal-box-footer">
          <button class="btn btn-success btn-block" @click="sendResetEmail" :disabled="resetLoading">
            <span v-if="resetLoading" class="spinner-border spinner-border-sm mr-1"></span>
            <span>送信</span>
          </button>
        </div>
      </div>
    </div>

    <!-- パスワード再設定モーダル -->
    <div v-if="showResetModal" class="modal-overlay">
      <div class="modal-box">
        <div class="modal-box-header">
          <h6 class="modal-box-title">パスワードを変更する</h6>
          <button class="modal-close" @click="closeResetModal">&times;</button>
        </div>
        <div class="modal-box-body">
          <div class="field-group">
            <label>新しいパスワード</label>
            <div class="password-wrap">
              <input :type="resetShowPw ? 'text' : 'password'" v-model="newPassword" class="form-control" placeholder="パスワード">
              <button type="button" class="pw-toggle" @click="resetShowPw = !resetShowPw">
                <i :class="resetShowPw ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
          </div>
          <div class="field-group">
            <label>パスワード確認</label>
            <div class="password-wrap">
              <input :type="resetShowPw ? 'text' : 'password'" v-model="confirmNewPassword" class="form-control" placeholder="パスワード確認">
              <button type="button" class="pw-toggle" @click="resetShowPw = !resetShowPw">
                <i :class="resetShowPw ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
          </div>
          <p v-if="resetMessage" :style="{ color: resetMessageError ? '#e53e3e' : '#38a169', fontSize: '13px', marginTop: '8px' }">{{ resetMessage }}</p>
        </div>
        <div class="modal-box-footer">
          <button class="btn btn-success btn-block" @click="updatePassword" :disabled="resetLoading">
            <span v-if="resetLoading" class="spinner-border spinner-border-sm mr-1"></span>
            <span>パスワードを変更する</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginHeadImg from '../../assets/img/timecard/login-head.png';

export default {
  data () {
    return {
      loginHead: loginHeadImg,
      showPassword: false,
      id: null,
      password: null,
      rememberMe: false,
      isLoading: false,
      data: null,
      shops: [],
      showShopSelect: false,
      // パスワードリセット
      showForgotModal: false,
      showResetModal: false,
      resetEmail: '',
      newPassword: '',
      confirmNewPassword: '',
      resetShowPw: false,
      resetLoading: false,
      resetMessage: '',
      resetMessageError: false,
    }
  },
  mounted() {
    // メールリンクからの遷移（?token=xxx&redirect=mobile）
    if (this.$route.query.token && this.$route.query.redirect === 'mobile') {
      this.showResetModal = true;
    }
  },
  methods: {
    sendResetEmail() {
      if (this.resetLoading) return;
      if (!this.resetEmail) {
        this.resetMessage = 'メールアドレスを入力してください';
        this.resetMessageError = true;
        return;
      }
      this.resetLoading = true;
      this.resetMessage = '';
      this.$http.post(process.env.VUE_APP_API_PATH + '/auth/reset-password', {
        email: this.resetEmail,
        redirect: 'mobile',
      })
      .then(() => {
        this.resetMessage = 'リセットメールを送信しました。メールをご確認ください。';
        this.resetMessageError = false;
        this.resetEmail = '';
      })
      .catch(() => {
        this.resetMessage = 'メール送信に失敗しました。メールアドレスをご確認ください。';
        this.resetMessageError = true;
      })
      .finally(() => { this.resetLoading = false; });
    },
    updatePassword() {
      if (this.resetLoading) return;
      if (this.newPassword.length < 6) {
        this.resetMessage = 'パスワードは6文字以上で入力してください';
        this.resetMessageError = true;
        return;
      }
      if (this.newPassword !== this.confirmNewPassword) {
        this.resetMessage = 'パスワードが一致しません';
        this.resetMessageError = true;
        return;
      }
      this.resetLoading = true;
      this.resetMessage = '';
      this.$http.post(process.env.VUE_APP_API_PATH + '/auth/update-password', {
        token: this.$route.query.token,
        password: this.newPassword,
      })
      .then(() => {
        this.resetMessage = 'パスワードが変更されました';
        this.resetMessageError = false;
        this.showResetModal = false;
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.$toast.success('パスワードが変更されました');
        // URLからtokenを除去
        this.$router.replace({ path: '/timecard/login' });
      })
      .catch(() => {
        this.resetMessage = 'パスワードの変更に失敗しました。リンクが期限切れの可能性があります。';
        this.resetMessageError = true;
      })
      .finally(() => { this.resetLoading = false; });
    },
    closeResetModal() {
      this.showResetModal = false;
      this.$router.replace({ path: '/timecard/login' });
    },
    login() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$http.post(process.env.VUE_APP_API_PATH + '/auth/login', {
        email: this.id,
        password: this.password,
        remember: this.rememberMe,
        is_mobile: true,
      })
      .then(response => {
        this.data = response.data;
        const shops = response.data.data.shops || [];
        this.shops = Array.isArray(shops) ? shops : Object.values(shops);
        if (this.shops.length === 0) {
          this.$toast.error('所属店舗がありません。管理者にご連絡ください。');
        } else if (this.shops.length === 1) {
          this.selectShop(this.shops[0]);
        } else {
          this.showShopSelect = true;
        }
        this.isLoading = false;
      })
      .catch(error => {
        if (error.response) {
          const response = error.response.data;
          if (response.errors) {
            this.$toast.error(response.errors.email ? response.errors.email[0] : response.message);
          } else {
            this.$toast.error(response.message);
          }
        }
        this.isLoading = false;
      });
    },
    async selectShop(shop) {
      this.data.data.shop_id = shop.id;
      this.data.data.shop_name = shop.shop_name;
      await this.$store.dispatch('setAuth', this.data);
      this.showShopSelect = false;
      this.$router.push({ name: 'PunchTime' });
    }
  }
}
</script>

<style scoped>
.tc-login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
}

.login-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 380px;
  overflow: hidden;
}

.login-header {
  background: #fff;
  padding: 32px 20px 16px;
  text-align: center;
  border-bottom: 2px solid #e2e8f0;
}

.login-logo {
  height: 70px;
  object-fit: contain;
}

.login-form {
  padding: 28px 24px;
}

.field-group {
  margin-bottom: 16px;
}

.field-group label {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 4px;
  display: block;
}

.field-group .form-control {
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 16px;
}

.password-wrap {
  position: relative;
}

.password-wrap .form-control {
  padding-right: 44px;
}

.pw-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  color: #718096;
  cursor: pointer;
  font-size: 16px;
}

.remember-row {
  margin-bottom: 20px;
}

.remember-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #718096;
  cursor: pointer;
  margin: 0;
}

.remember-label input {
  width: 16px;
  height: 16px;
}

.btn-login {
  width: 100%;
  padding: 12px;
  background: #049C4C;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-login:hover:not(:disabled) {
  background: #038a42;
}

.btn-login:disabled {
  opacity: 0.7;
}

.forgot-link {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 0;
}

.forgot-link a {
  color: #049C4C;
  font-size: 13px;
}

/* Vue modal */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  background: #fff;
  border-radius: 16px;
  width: 340px;
  max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  overflow: hidden;
}

.modal-box-header {
  padding: 16px 20px;
  border-bottom: 1px solid #edf2f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-box-title {
  font-weight: 700;
  font-size: 15px;
  margin: 0;
}

.modal-close {
  border: none;
  background: none;
  font-size: 22px;
  color: #718096;
  cursor: pointer;
  line-height: 1;
}

.modal-box-footer {
  padding: 12px 20px 16px;
}

.modal-box-body {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shop-select-btn {
  width: 100%;
  padding: 14px 16px;
  border: 1.5px solid #d2d6dc;
  border-radius: 10px;
  background: #fff;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s;
}

.shop-select-btn:hover {
  border-color: #049C4C;
  background: #f0fff4;
  color: #049C4C;
}
</style>
